import type { DataLayerEventName, EventData } from '@/main/lib/services/Gtm/entities';
import type { Tinypass } from '@/main/lib/services/Piano/entities/Tinypass';
import { getLts } from '@/main/lib/services/Piano/pianoHandlers';

interface pianoTemplateTrackingEvent {
  eventName: string;
  type: string;
  params: {
    contentPlacement?: string;
    displayMode: string;
    clickText?: string;
    clickType?: 'close' | 'cta button' | 'expand' | 'collapse' | 'sign in link';
    formName?: string;
    experienceId?: string;
  };
}

export const pianoTemplateTrackingEvent = (
  tp: Tinypass,
  event: pianoTemplateTrackingEvent,
  sendEventOnConsent: (eventData: EventData, eventType?: DataLayerEventName) => void,
) => {
  switch (event.type) {
    case 'nlTemplateClick': {
      const { contentPlacement, displayMode, clickText, clickType } = event.params;

      const templateTrackingPayload = {
        eventAction: 'newsletter template clicked',
        eventLabel: 'user clicked on newsletter template',
        eventCategory: 'piano template',
        displayMode: displayMode,
        manualContentPlacement: contentPlacement,
        manualClickText: clickText,
        manualClickType: clickType,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    case 'templateFormStart': {
      const { displayMode, formName, experienceId } = event.params;

      const lts = experienceId ? getLts(tp, experienceId, 'showTemplate') : null;

      const templateTrackingPayload = {
        eventAction: 'template form started',
        eventLabel: 'user started filling out template form',
        eventCategory: 'piano template',
        displayMode: displayMode,
        formName: formName,
        logged_in: Boolean(tp.pianoId.getUser()),
        lts: lts,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    case 'templateFormSubmitted': {
      const { displayMode, formName, experienceId } = event.params;

      const lts = experienceId ? getLts(tp, experienceId, 'showTemplate') : null;

      const templateTrackingPayload = {
        eventAction: 'template form submitted',
        eventLabel: 'user successfully submitted template form',
        eventCategory: 'piano template',
        displayMode: displayMode,
        formName: formName,
        logged_in: Boolean(tp.pianoId.getUser()),
        lts: lts,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    default:
      break;
  }
};
